import { Expose, Type } from "class-transformer";
import { IsBoolean, IsEnum, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import GenericTableResponse from "@/models/api/GenericTableResponse";
import { KSEF_STATUS_ENUM } from "@/static/ksefStatusEnum";

class OrderListItemContractor {
  @IsString()
  @Expose()
  name!: string;
  @IsOptional()
  @IsString()
  @Expose()
  surname!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  tin!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  city!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  streetAndNumber!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  postalCode!: string | null;
  @IsNumber()
  @Expose()
  relationType!: number;
}

class OrderListItemDocument {
  @IsString()
  @Expose()
  id!: string;
  @IsString()
  @Expose()
  documentNumber!: string;
  @IsNumber()
  @Expose()
  price!: number;
  @IsNumber()
  @Expose()
  formOfPaymentId!: number;
  @IsBoolean()
  @Expose()
  isCancelled!: boolean;
  @IsNumber()
  @Expose()
  recordStampId!: number;
  @IsBoolean()
  @Expose()
  isEditingLocked!: boolean;
  @IsOptional()
  @IsString()
  @Expose()
  ksefNumber!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  ksefAcquisitionDate!: string | null;
  @IsEnum(KSEF_STATUS_ENUM)
  @Expose()
  ksefStatus!: KSEF_STATUS_ENUM;
}

export class OrderListItem {
  @Type(() => OrderListItemDocument)
  @Expose()
  documents!: Array<OrderListItemDocument>;
  @IsBoolean()
  @Expose()
  setTemporaryPermission!: boolean;
  @IsBoolean()
  @Expose()
  canEdit!: boolean;
  @IsBoolean()
  @Expose()
  canRemove!: boolean;
  @IsBoolean()
  @Expose()
  isTemporary!: boolean;
  @IsBoolean()
  @Expose()
  isMailReminder!: boolean;
  @IsBoolean()
  @Expose()
  hasReceipt!: boolean;
  @IsBoolean()
  @Expose()
  hasReturnProtocol!: boolean;
  @IsBoolean()
  @Expose()
  hasBookingItems!: boolean;
  @IsString()
  @Expose()
  id!: string;
  //  @Expose()
  //Owner: string;
  @IsString()
  @Expose()
  createdAt!: string;
  @Expose()
  gross!: number;
  @IsOptional()
  @IsString()
  @Expose()
  comment!: string | null;
  @IsString()
  @Expose()
  currency!: string;
  @Type(() => OrderListItemContractor)
  @ValidateNested()
  @Expose()
  contractors!: Array<OrderListItemContractor>;
  //@Expose()
  //FormOfPaymentId: number;
  @IsBoolean()
  @Expose()
  hasImportedContractor!: boolean;
  @IsBoolean()
  @Expose()
  hasBuyer!: boolean;
  @IsBoolean()
  @Expose()
  hasDocuments!: boolean;
  @IsBoolean()
  @Expose()
  hasOnlyProforma!: boolean;
  @IsBoolean()
  @Expose()
  onlyReceiptIssued!: boolean;
  @IsBoolean()
  @Expose()
  isExported!: boolean;
  @IsBoolean()
  @Expose()
  isFromExport!: boolean;
  @IsBoolean()
  @Expose()
  isCorrection!: boolean;
  @IsNumber()
  @Expose()
  recordStampId!: number;
  @IsNumber()
  @Expose()
  stateToSendDocumentsView!: number;
  @IsBoolean()
  @Expose()
  canMakeCorrection!: boolean;
  @IsBoolean()
  @Expose()
  canMakeFormalCorrection!: boolean;
  @IsBoolean()
  @Expose()
  advanceIsImportedToDocument!: boolean;
  @IsBoolean()
  @Expose()
  isErrorSend!: boolean;
  @IsBoolean()
  @Expose()
  canMerge!: boolean;
  @IsBoolean()
  @Expose()
  canMakeReturnProtocol!: boolean;
  @IsString()
  @Expose()
  timestamp!: string;
}

export class OrderListResponse extends GenericTableResponse<OrderListItem> {
  @Type(() => OrderListItem)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  items: Array<OrderListItem>;
}
